import { Routes } from '@angular/router';
import { LoginComponent } from './core/auth/pages/login/login.component';
import { loginGuard } from './core/auth/guards/login.guard';
import { mainRoutes } from './core/main-layout/main-layout.routes';
import { ErrorRoutes } from './core/components/404/error.routes';

export const routes: Routes = [
  ...mainRoutes,
  ...ErrorRoutes,
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
  },
  { path: '**', redirectTo: 'miscellaneous/error' },
];
